import { DEVICESTATUS } from "../globals/globals";

export const resolveDeviceStatusLabel = (status: string | number | null | undefined) => {
  if (status === null || status === undefined) {
    return "Unknown";
  }

  const statusText = status.toString().trim();
  if (!statusText) {
    return "Unknown";
  }

  switch (statusText) {
    case DEVICESTATUS.TIMEOUT:
      return "Disconnected";
    case DEVICESTATUS.NORMAL:
      return "Connected";
    case DEVICESTATUS.MINOR:
      return "Minor";
    case DEVICESTATUS.MAJOR:
      return "Major";
    case DEVICESTATUS.CRITICAL:
      return "Critical";
    case DEVICESTATUS.MAINTENANCE_MODE:
      return "InMaintenance";
    case DEVICESTATUS.SPPROFILE_RUNNING:
      return "InProgress";
    default:
      break;
  }

  const upper = statusText.toUpperCase();
  switch (upper) {
    case "IS-NORMAL":
    case "IS-IDLE":
    case "IS-NETMON":
      return "Connected";
    case "OOS-NOTPRESENT":
    case "OOS-DISABLED":
    case "OOS-INHERITED":
      return "Disconnected";
    case "OOS-FAULT":
      return "Critical";
    case "IS-DEGRADED":
      return "Minor";
    case "CRITICAL":
      return "Critical";
    case "MAJOR":
      return "Major";
    case "MINOR":
      return "Minor";
    case "UNKNOWN":
      return "Unknown";
    default:
      break;
  }

  const normalized = statusText.toLowerCase();
  switch (normalized) {
    case "up":
    case "enabled":
    case "online":
    case "connected":
    case "active":
      return "Connected";
    case "down":
    case "disabled":
    case "offline":
    case "disconnected":
    case "inactive":
      return "Disconnected";
    case "clear":
    case "cleared":
      return "Cleared";
    default:
      return statusText;
  }
};
